'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  padding: 0.8em 1.2em;\n  border: none;\n  border-radius: 3px;\n  font-size: 1em;\n  letter-spacing: .035em;\n  cursor: pointer;\n  width: 100%;\n  text-align: center;\n  transition: all 0.3s ease-in;\n  text-align: center;\n  text-transform: uppercase;\n  text-decoration: none;\n  outline: none;\n  font-weight: 400;\n  ', '\n\n  @media ', ' {\n    width: ', ';\n  }\n'], ['\n  display: inline-block;\n  padding: 0.8em 1.2em;\n  border: none;\n  border-radius: 3px;\n  font-size: 1em;\n  letter-spacing: .035em;\n  cursor: pointer;\n  width: 100%;\n  text-align: center;\n  transition: all 0.3s ease-in;\n  text-align: center;\n  text-transform: uppercase;\n  text-decoration: none;\n  outline: none;\n  font-weight: 400;\n  ', '\n\n  @media ', ' {\n    width: ', ';\n  }\n']);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var defaultColorScheme = '\n  border: 1px solid ' + _styles.styles.colors.lightborder + ';\n  color: ' + _styles.styles.colors.darkfg + ';\n  background-color: ' + _styles.styles.colors.mediumbg + ';\n  &:hover {\n    background-color: ' + _styles.styles.colors.lighten(_styles.styles.colors.mediumbg) + ';\n  }\n';
var primaryColorScheme = '\n  border: 1px solid ' + _styles.styles.colors.primary_btn + ';\n  color: ' + _styles.styles.colors.lightfg + ';\n  background-color: ' + _styles.styles.colors.primary_btn + ';\n  &:hover {\n    background-color: ' + _styles.styles.colors.lighten(_styles.styles.colors.primary_btn) + ';\n  }\n';
var secondaryColorScheme = '\n  border: 1px solid ' + _styles.styles.colors.secondary_btn + ';\n  color: ' + _styles.styles.colors.lightfg + ';\n  background-color: ' + _styles.styles.colors.secondary_btn + ';\n  &:hover {\n    background-color: ' + _styles.styles.colors.lighten(_styles.styles.colors.secondary_btn) + ';\n  }\n';
var zenColorScheme = '\n  border: 1px solid ' + _styles.styles.colors.lightborder + ';\n  color: ' + _styles.styles.colors.darkfg + ';\n  background-color: ' + _styles.styles.colors.lightbg + ';\n  &:hover {\n    color: ' + _styles.styles.colors.secondary_btn + ';\n    opacity: 0.95;\n  }\n';
var colorScheme = R.cond([[R.has('primary'), R.always(primaryColorScheme)], [R.has('secondary'), R.always(secondaryColorScheme)], [R.has('zen'), R.always(zenColorScheme)], [R.T, R.always(defaultColorScheme)]]);

/*::
type ButtonProps = {
  full?: bool,
  primary?: bool,
  secondary?: bool,
}
*/
var Button /*: ComponentType<ButtonProps> */ = exports.Button = _styledComponents2.default.button(_templateObject, colorScheme, _styles.styles.media.tablet, function (props) {
  return props.full ? '100%' : 'auto';
});


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/Buttons.js
// module id = 77
// module chunks = 0